<div
  class="custom-img"
  appLazyLoad="{{file + '?format=webp'}}" [isBackground]="true"
  [ngClass]="[
    imageFit === 'Fit Without Cropping' ? 'fit-without-cropping' : 'fill-and-crop',
    imagePosition ? imagePosition.replace(' ', '-') : ''
  ]"></div>
